import React, { useEffect, useState } from 'react';
import useWarehouseOrderItemService from '../../../app/services/hooks/useWarehouseOrderItemService';
import {
    defaultWarehouseOrderItemDataForm,
    WarehouseOrderItemDataForm
} from '../../../app/models/WarehouseOrderItem';
import { Product } from '../../../app/models/Product';
import { Unit } from '../../../app/models/Unit';
import { Currency } from '../../../app/models/Currency';
import { Place } from '../../../app/models/Place';
import { Service } from '../../../app/models/Service';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import WarehouseOrderItemForm from './forms/WarehouseOrderItemForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import LazyLoading from '../../../components/LazyLoading';
import useSweetAlert from '../../../hooks/useSweetAlert';
import { WarehouseOrderDataForm } from '../../../app/models/WarehouseOrder';
import { Routes } from '../../../app/models/RouteSegment';
import useQuoteRouteSegmentService from '../../../app/services/hooks/useQuoteRouteSegmentService';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { Depot } from '../../../app/models/Depot';
import { QuoteDetailFormTypeEnum } from '../../../app/shared/enums';

interface Props {
    canBeEdited: boolean;
    warehouseOrderId: number;
    warehouseOrderItemId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: (message?: string) => void;
}

const WarehouseOrderItemEdit = ({
    canBeEdited,
    warehouseOrderId,
    warehouseOrderItemId,
    onSaved,
    onCancel,
    onError
}: Props) => {
    const {
        editWarehouseOrderItem,
        updateWarehouseOrderItem,
        showStorageDataToWareHouseOrderDetail,
        fetchingEditWarehouseOrderItem,
        fetchingUpdateWarehouseOrderItem
    } = useWarehouseOrderItemService();


    const [errorFields, setErrorFields] = useState<any>();

    // const [warehouseOrderItemForm, setWarehouseOrderItemForm] =
    //     useState<WarehouseOrderItemDataForm>({
    //         ...defaultWarehouseOrderItemDataForm,
    //         warehouse_order_id: warehouseOrderId
    //     });

    const [warehouseOrderItemForm, setWarehouseOrderItemForm] =
        useState<WarehouseOrderItemDataForm>({
            ...defaultWarehouseOrderItemDataForm,
            // ['warehouse_order_id']: warehouseOrderId,
            // ['currency_id']: currencyId,
            // ['route_id']: 0
        });
    const [warehouseOrderItemEditForm, setWarehouseOrderitemEditForm] =
        useState<WarehouseOrderItemDataForm>({
            ...defaultWarehouseOrderItemDataForm,
            // ['currency_id']: currencyId,
        });

    const [products, setProducts] = useState<Product[]>([]);
    const [quantityUnits, setQuantityUnits] = useState<Unit[]>([]);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [services, setServices] = useState<Service[]>([]);
    const [disabled, setDisabled] = useState<boolean>(false);
    const [routes, setRoutes] = useState<Routes[]>([]);
    const [hasQuote, setHasQuote] = useState<boolean>(false);
    const [depots, setDepots] = useState<Depot[]>([]);
    const [units, setUnits] = useState<Unit[]>([]);
   const [disableStorage, setDisableStorage] = useState<boolean>(false);
    const [disableRate, setDisableRate] = useState<boolean>(false);

    const isWarehouseForm =
        services.find((s) => s.id === warehouseOrderItemForm.service_id)
            ?.quote_detail_form_type === QuoteDetailFormTypeEnum.WAREHOUSE;
        
    useEffect(() => {
        if (warehouseOrderItemId) {
            edit();
        }
    }, [warehouseOrderItemId]);

    // Limpiar campos exclusivos de almacenamiento cuando el servicio no es WAREHOUSE
    useEffect(() => {
        if (warehouseOrderItemForm.service_id && services.length > 0 && !isWarehouseForm) {
            setWarehouseOrderItemForm((prev) => ({
                ...prev,
                depot_id: undefined,
                free_days: 0,
            }));
        }
    }, [warehouseOrderItemForm.service_id, services.length, isWarehouseForm]);

    // useEffect(() => {
    //     if (services.length) {
    //         setWarehouseOrderItemForm({
    //             ...warehouseOrderItemForm,
    //             service_id: services[0].id
    //         });
    //     }
    // }, [services]);

    const edit = () => {
        console.log('edit')
        editWarehouseOrderItem(warehouseOrderItemId, {
            onSuccess: (response: ServiceResponse) => {
                    setWarehouseOrderItemForm( response.data.warehouse_order_item);
                    setServices(response.data.services);
                    setProducts(response.data.products);
                    setQuantityUnits(response.data.units);
                    setDepots(response.data.depots);
                    setCurrencies(response.data.currencies);
                    setUnits(response.data.units);

                if (response.data.routes_data.has_quote) {
                    console.log('tiene quote route segment');
                    setRoutes(response.data.routes_data.routes);

                    setHasQuote(true);
                } else {
                    console.log('no tiene quote route segment');
                    setRoutes(response.data.routes_data.routes);
                }

                if (response.data.warehouse_order_item.status_selected?.id === 'FINALIZADO') {
                    setDisabled(true);
                }
                setWarehouseOrderItemForm(response.data.warehouse_order_item);
                // setWarehouseOrderitemEditForm({
                //     quantity: response.data.warehouse_order_item.quantity,
                //     // rate: response.data.warehouse_order_item.rate,
                //     quantity_unit_id: response.data.warehouse_order_item.quantity_unit_id,
                //     currency_id: response.data.warehouse_order_item.currency_id,
                //     rate_unit_id: response.data.warehouse_order_item.rate_unit_id,
                //     agreed_distance: response.data.warehouse_order_item.agreed_distance,
                // });
            },
            onError: (response: ServiceResponse) => {
                useSweetAlert().errorAlert({
                    title: 'Error',
                    text: response.message
                });
                if (onError) onError(response.message);
            },
            onFieldError: (errorFields: ServiceResponse) => {
                setErrorFields(errorFields.data);
            }
        });
    };

    const update = () => {
        useSweetAlert().spinnerAlert('Actualizando detalle pedido...', 400);
        updateWarehouseOrderItem(warehouseOrderItemId, warehouseOrderItemForm, {
            onSuccess: (response: ServiceResponse) => {
                useSweetAlert().closeSpinnerAlert();
                toast.success(response.message);

                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                useSweetAlert().closeSpinnerAlert();
                toast.error(response.message);
                
            },
            onFieldError: (errorFields: ServiceResponse) => {
                useSweetAlert().closeSpinnerAlert();
                setErrorFields(errorFields.data);
            }
        });
    };

        // Función para mapear los datos del API al formulario
        const mapStorageDataToForm = (storageData: any) => {
            const freeDaysData = storageData.free_days?.[0];

            if (!freeDaysData) {
                return {}; // No hay datos para mapear
            }

            return {
                // Días libres
                free_days: freeDaysData?.free_days || 0,
            };
        };
        
        useEffect(() => {
            // Solo para formulario WAREHOUSE: cargar datos de almacenamiento al elegir almacén/producto
            if (
                isWarehouseForm &&
                warehouseOrderItemForm.depot_id &&
                warehouseOrderItemForm.product_id &&
                currencies.length > 0 &&
                units.length > 0
            ) {
                showStorageDataToWareHouseOrderDetail(warehouseOrderId, warehouseOrderItemForm.depot_id, warehouseOrderItemForm.product_id, {
                    onSuccess: (response: ServiceResponse) => {
                        setErrorFields(undefined);
                        
                        // Mapear los datos del almacenamiento al formulario
                        const mappedStorageData = mapStorageDataToForm(response.data);
                        setDisableStorage(response.data.has_storage)
                        
                        setWarehouseOrderItemForm(prevForm => ({
                            ...prevForm,
                            ...mappedStorageData
                        }));
                    },
                    onError: (response: ServiceResponse) => {
                        // Si no se encuentran datos, limpiar los campos relacionados
                        setWarehouseOrderItemForm(prevForm => ({
                            ...prevForm,
                            free_days: 0,
                            comment: ''
                        }));
                    }
                });
            }
        }, [isWarehouseForm, warehouseOrderItemForm.product_id, warehouseOrderItemForm.depot_id, currencies.length, units.length]);
    

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    {!fetchingEditWarehouseOrderItem ? (
                        <WarehouseOrderItemForm
                            warehouseOrderItemForm={warehouseOrderItemForm}
                            setWarehouseOrderItemForm={setWarehouseOrderItemForm}
                            services={services}
                            products={products}
                            currencies={currencies}
                            units={units} 
                            depots={depots}
                            quantityUnits={quantityUnits}
                            errorFields={errorFields}
                            disableUpdate={false}
                            disableRate={disableRate}
                            disableStorage={disableStorage}
                            isWarehouseForm={isWarehouseForm}
                        />
                    ) : (
                        <LazyLoading height="300" />
                    )}
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm
                        callbackCancel={cancel}
                        locked={fetchingUpdateWarehouseOrderItem}
                    />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm
                        callbackSave={update}
                        locked={fetchingUpdateWarehouseOrderItem}
                    />
                </div>
            </div>
        </>
    );
};

export default WarehouseOrderItemEdit;
